import './NotFound.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div className="card">
        <div className="title">
          <p>\(o_o)/</p>
          <h2>{ t('NotFound.content') }</h2>
        </div>
        <Link to="/" className="link-button">{ t('NotFound.back') }</Link>
      </div>
    </div>
  );
}
